import React from 'react'
import appApi from '../../classes/appApi'
import generateContextProvider from '../../shared/hooks/GenerateContextProvider'
import { useBaseConfigContext } from './AppBaseConfig'
import { useTenantLookupContext } from './AppTenantLookupProvider'

//@todo - move appApi here
const ApiWrapper = (props: {
    provider: React.FC<{ value: appApi; children: React.ReactNode }>
    children: React.ReactNode
}) => {
    const ApiProvider = props.provider

    const config = useBaseConfigContext()
    const { tenantUrlPrefix } = useTenantLookupContext()

    const api = new appApi({
        config: config.api,
        tenantUrlPrefix,
    })

    return <ApiProvider value={api}>{props.children}</ApiProvider>
}

const {
    ContextProvider: AppApiProvider,
    useContext: useApiContext,
    useContextOptional: useApiContextOptional,
} = generateContextProvider<appApi>(undefined, ApiWrapper)

const TenantlessApiWrapper = (props: {
    provider: React.FC<{ value: appApi; children: React.ReactNode }>
    children: React.ReactNode
}) => {
    const ApiProvider = props.provider

    const config = useBaseConfigContext()

    const api = new appApi({
        config: config.api,
    })

    return <ApiProvider value={api}>{props.children}</ApiProvider>
}

const {
    ContextProvider: TenantlessAppApiProvider,
    useContext: useTenantlessApiContext,
    useContextOptional: useTenantlessApiContextOptional,
} = generateContextProvider<appApi>(undefined, TenantlessApiWrapper)

export { AppApiProvider as default, TenantlessAppApiProvider, useApiContext, useApiContextOptional, useTenantlessApiContext, useTenantlessApiContextOptional }
